import _ from "lodash";
import ApiOutlinedIcon from "@mui/icons-material/ApiOutlined";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import ExtensionOutlinedIcon from "@mui/icons-material/ExtensionOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import SensorsOutlinedIcon from "@mui/icons-material/SensorsOutlined";
import SmartToyOutlinedIcon from "@mui/icons-material/SmartToyOutlined";
import TagOutlinedIcon from "@mui/icons-material/TagOutlined";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const ICONS = {
    "core-automations": SensorsOutlinedIcon,
    "data-export": FileDownloadOutlinedIcon,
    reports: PictureAsPdfOutlinedIcon,
    api: ApiOutlinedIcon,
    mcp: SmartToyOutlinedIcon,
    "whatsapp-notifications": WhatsAppIcon,
    "whatsapp-assistant": AutoAwesomeOutlinedIcon,
    "slack-notifications": TagOutlinedIcon,
};

export const pluginIcon = (plugin) => ICONS[plugin?.slug] || ExtensionOutlinedIcon;

export const hasConfig = (plugin) => !_.isEmpty(plugin?.data_fields);

const normalize = (text) => _.deburr(`${text || ""}`).toLowerCase();

// Busca por nombre, categoría y descripción, sin importar tildes ni mayúsculas.
export const matchesSearch = (plugin, search) => {
    const query = normalize(search).trim();
    if (!query) return true;
    return normalize([plugin.name, plugin.category, plugin.description].join(" ")).includes(query);
};

// Primero los instalados y después el resto; dentro de cada grupo, el orden del backend (categoría y nombre).
export const installedFirst = (plugins) => _.sortBy(plugins, (plugin) => (plugin.installed ? 0 : 1));

// Las categorías para el filtro, en el orden en que vienen del backend.
export const categoriesOf = (plugins) => _.uniq(_.compact(_.map(plugins, "category")));

// Los plugins que este requiere y que la empresa todavía no tiene instalados.
export const missingRequirements = (plugin) => _.filter(plugin?.requires, (required) => !required.installed);

export const pluginErrorMessage = (error, fallback) => {
    const data = error?.response?.data;
    if (Array.isArray(data?.errors) && data.errors.length) return data.errors.join(". ");
    return data?.msg || data?.error || fallback;
};
